export default __webpack_public_path__ + "09a10346f68b2edee4383989d99f167c.png";